import type { ReactNode } from "react";
import VikeRootLayout from "../src/vike/VikeRootLayout";

export default function Layout({ children }: { children: ReactNode }) {
  return <VikeRootLayout>{children}</VikeRootLayout>;
}
